import { nextBackgroundTaskRunId } from './backgroundTasks.module'

const SET_TASKS = 'SET_TASKS'

const isString = (value) => typeof value === 'string'

const toTask = (task, runId) => ({
  id: task.id,
  name: isString(task.name) ? task.name : '',
  pendingTitle: isString(task.pendingTitle) ? task.pendingTitle : '',
  pendingBody: isString(task.pendingBody) ? task.pendingBody : '',
  successText: isString(task.successText) ? task.successText : '',
  status: ['converting', 'ready', 'failed'].includes(task.status) ? task.status : 'converting',
  openPath: isString(task.openPath) ? task.openPath : null,
  errorText: isString(task.errorText) ? task.errorText : '',
  runId,
})

const actions = {
  receiveHostedEmbedTaskAction({ commit, state }, task) {
    if (!task || !isString(task.id)) return
    const existing = state.tasks.find((current) => current.id === task.id)
    const restarted = !!existing && existing.status !== 'converting' && task.status === 'converting'
    const keepsPlace = !!existing && !restarted
    const next = {
      ...toTask(task, keepsPlace ? existing.runId : nextBackgroundTaskRunId()),
      dismissed: keepsPlace && existing.dismissed,
    }
    commit(SET_TASKS, existing
      ? state.tasks.map((current) => (current.id === task.id ? next : current))
      : [...state.tasks, next])
  },

  dismissHostedEmbedTaskAction({ commit, state }, id) {
    commit(SET_TASKS, state.tasks.map((task) => (task.id === id ? { ...task, dismissed: true } : task)))
  },
}

export default {
  namespaced: true,
  state: () => ({ tasks: [] }),
  getters: {
    hostedEmbedTasks: (state) => state.tasks.filter((task) => !task.dismissed),
  },
  actions,
  mutations: {
    [SET_TASKS](state, tasks) {
      state.tasks = tasks
    },
  },
}
